export const EVALUATION_RESULTS = {
    CORRECT: "correct",
    INCORRECT: "incorrect",
    PARTIALLY_CORRECT: "partially_correct"
  } as const;

  export type EvaluationResult = "correct" | "incorrect" | "partially_correct";

  export const EVALUATION_RESULT_LABELS = {
    [EVALUATION_RESULTS.CORRECT]: "Correct",
    [EVALUATION_RESULTS.INCORRECT]: "Incorrect", 
    [EVALUATION_RESULTS.PARTIALLY_CORRECT]: "Partially Correct"
  } as const;
  
  export const EVALUATION_RESULT_OPTIONS = [
    { value: EVALUATION_RESULTS.CORRECT, label: EVALUATION_RESULT_LABELS[EVALUATION_RESULTS.CORRECT] },
    { value: EVALUATION_RESULTS.INCORRECT, label: EVALUATION_RESULT_LABELS[EVALUATION_RESULTS.INCORRECT] },
    { value: EVALUATION_RESULTS.PARTIALLY_CORRECT, label: EVALUATION_RESULT_LABELS[EVALUATION_RESULTS.PARTIALLY_CORRECT] }
  ];

  export const ATTEMPT_STATUS={
    ATTEMPTED:"attempted",
    UNATTEMPTED:"unattempted"
} as const;

  export type AttemptStatus = "attempted" | "unattempted";

  export const ATTEMPT_STATUS_LABELS = {
    [ATTEMPT_STATUS.ATTEMPTED]:"Attempted",
    [ATTEMPT_STATUS.UNATTEMPTED]:"Unattempted"
} as const;

export const ATTEMPT_STATUS_OPTIONS = [
  { value: ATTEMPT_STATUS.ATTEMPTED, label: ATTEMPT_STATUS_LABELS[ATTEMPT_STATUS.ATTEMPTED] },
  { value: ATTEMPT_STATUS.UNATTEMPTED, label: ATTEMPT_STATUS_LABELS[ATTEMPT_STATUS.UNATTEMPTED] }
];